import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '../components/components.module';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { UiSwitchModule } from 'ngx-ui-switch';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ReportsService } from './reports.service';
import { QuicksightReportsRolesService } from './quicksight-reports-roles.service';
import { ReportResolver } from './reports-resolver';
import { ReportsComponent } from './reports.component';
import { NewReportModalComponent } from './new-report/new-report.component';
import { FederatedIdentityGroupService } from '../federated-identity-groups/federated-identity-group.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ComponentsModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TableModule,
        FormsModule,
        RouterModule,
        UiSwitchModule,
    ],
    declarations: [
        NewReportModalComponent,
        ReportsComponent
    ],
    exports: [
        ReportsComponent
    ],
    providers: [
        ReportsService,
        QuicksightReportsRolesService,
        FederatedIdentityGroupService,
        { provide: 'ReportResolver', useValue: ReportResolver },
        BsModalService,
    ]
})
export class ReportsModule {
}
